import { Button, Input, Table } from 'antd';
import './admin-active-company-list.css';
import { useDispatch, useSelector } from 'react-redux';
import { setOpenKeys, setPageTitle, setSelectedMenuItemKeys } from '../../../../../../redux/reducer/antd-layout.reducer';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useRevalidator } from 'react-router-dom';
import { showDefaultErrorMessages } from '../../../../../../util/show-default-error-message/show-default-error-messages';
import { AlertMessageState, clearAlertMessage, showAlertMessage } from '../../../../../../redux/reducer/alert-message.reducer';
import { SearchOutlined } from '@ant-design/icons';
import { networkCall } from '../../../../../../util/network-call/network-call';
import { FilterDropdownProps } from 'antd/es/table/interface';
import { RootState } from '../../../../../../redux/store';
import { DeleteButton } from '../../../../../button/delete-button/delete-button';

type TableDataType = {
    key: React.Key,
    name: string;
};

export const AdminActiveCompanyList = () => {

    const dispatch = useDispatch();
    const loaderData: any = useLoaderData();
    const navigate = useNavigate();
    const reValidator = useRevalidator();
    const { searchTerm, siderCollapsed } = useSelector((state: RootState) => state.antdLayoutState);

    const handleDeleteClick = async (e: React.MouseEvent, id: React.Key) => {
        e.stopPropagation();

        if(window.confirm('Biztos törölni szeretnéd? Ha törlöd, akkor minden hozzárendelt felhasználó törlődni fog a rendszerből.')) {

            dispatch(clearAlertMessage());
            dispatch(showAlertMessage({
                alertMessageType: 'loading',
                alertMessageText: 'Kérés folyamatban...'
            }));

            const response = await networkCall(`/companies/${ id }/soft-delete`, {
                method: 'DELETE'
            });;

            const messageShowed = showDefaultErrorMessages(response);
            if(messageShowed) return;

            if(response.status === 204) {
                reValidator.revalidate();
                dispatch(showAlertMessage({
                    alertMessageType: 'success',
                    alertMessageText: 'Törlés sikeres.'
                }));
                return;
            }

            dispatch(clearAlertMessage());
            const alertMessageState: AlertMessageState = {
                alertMessageType: 'error',
                alertMessageText: 'Ismeretlen hiba történt. Kérjük próbálja újra!'
            };

            if(response.status === 404) {
                alertMessageState.alertMessageText = 'Törlés sikertelen, a törlendő cég nem létezik.';
            }

            dispatch(showAlertMessage(alertMessageState));

        }

    };
    
    const columns = [
        {
            title: 'Név',
            dataIndex: 'name',
            sorter: (a: TableDataType, b: TableDataType) => String(a.name).localeCompare(b.name),
            /*filterDropdown: ({ confirm, setSelectedKeys, selectedKeys }: FilterDropdownProps) => {
                return <Input
                    autoFocus
                    value={selectedKeys[0]}
                    placeholder='Keresés...'
                    onInput={(e: any) => {
                        setSelectedKeys( e.target.value ? [e.target.value] : [] );
                        confirm({ closeDropdown: false });
                    }}
                />;
            },
            filterIcon: () => {
                return <SearchOutlined />;
            },
            onFilter: (value: any, record: TableDataType) => {
                return record.name.toLowerCase().includes(value.toLowerCase());
            }*/
        },
        {
            title: 'Törlés',
            render: (record: TableDataType) => {
                return <DeleteButton onClick={(e) => handleDeleteClick(e, record.key)} />
            }
        }
    ];
    const [data, setData] = useState<TableDataType[]>([]);

    useEffect(() => {
        const messageShowed = showDefaultErrorMessages(loaderData);
        if(messageShowed) return;

        if(loaderData.getCompaniesResponse?.status === 200 && loaderData.getCompaniesResponse?.data?.companies) {
            const tableData: TableDataType[] = [];
            for (const company of loaderData.getCompaniesResponse.data.companies) {

                if(company.name.toLowerCase().includes(searchTerm.toLowerCase())) {
                    tableData.push({
                        key: company.id,
                        name: company.name
                    });
                }
                
            }

            setData(tableData);
            return;
        }

        dispatch(clearAlertMessage());
        const alertMessageState: AlertMessageState = {
            alertMessageType: 'error',
            alertMessageText: 'Ismeretlen hiba történt a cégek listázása során. Kérjük próbálja újra!'
        };

        dispatch(showAlertMessage(alertMessageState));

    }, [loaderData, searchTerm, dispatch]);

    useEffect(() => {
        dispatch(setSelectedMenuItemKeys(['active-companies']));
        if(!siderCollapsed) dispatch(setOpenKeys(['companies']));
        dispatch(setPageTitle('Aktív cégek'));
    }, [dispatch, siderCollapsed]);

    return (
        <>
            <div style={{ display: 'flex', justifyContent: 'flex-end', paddingBottom: '5px' }}>

                <Link to='/cms/admin/companies/add'><Button type='primary' className='fw-bold'>Új cég hozzáadása</Button></Link>
                
            </div>

            <Table
                className='table-responsive data-table'
                columns={columns}
                dataSource={data}
                bordered
                rowClassName={(record, name) => 'admin-active-company-table-row'}
                onRow={(row, rowIndex) => {
                    return {
                        onClick: (e) => {
                            navigate(`/cms/admin/companies/edit/${row.key}`);
                        }
                    }
                }}
                pagination={{ position: ['bottomCenter'], pageSize: 10}}
            />

        </>
    )
}